import axios from 'axios'

// Parola sıfırlama uçları anonimdir. Tarayıcıda duran eski/geçersiz bir token
// gönderilirse istek gereksiz yere 401'e düşüp login'e yönlendirilebiliyor
// (aktivasyon akışında birebir bu yaşanmıştı). Bu yüzden Authorization
// başlığı bu isteklerden çıkarılır.
const anonymous = {
    transformRequest: [function stripAuthorization(data, headers){
        if(headers){
            if(headers.common) delete headers.common.Authorization
            if(headers.post) delete headers.post.Authorization
            delete headers.Authorization
        }
        // transformRequest zincirinin başındayız; gövdeyi JSON'a çevirmek bize kalıyor.
        return data == null ? data : JSON.stringify(data)
    }],
    headers: { 'Content-Type': 'application/json' }
}

export const AuthApi = {
    async Login(data){
        const response = await axios.post('/api/auth/login',data)
        return response
    },
    // "Şifremi unuttum": e-posta adresine süreli sıfırlama bağlantısı gönderir.
    // Hesap kayıtlı olsun olmasın aynı yanıt döner.
    async ForgotPassword(data){
        const response = await axios.post('/api/auth/forgot-password',data,anonymous)
        return response
    },
    // Sıfırlama ekranı açılırken bağlantının hâlâ geçerli olup olmadığını sorar.
    // Jeton BİLİNÇLİ olarak URL'de değil gövdede taşınır: sunucu erişim logları
    // URL'i olduğu gibi yazar, jeton oralarda kalıcı hâle gelirdi.
    async ValidateResetToken(token){
        const response = await axios.post('/api/auth/reset-password/validate',{ Token:token },anonymous)
        return response
    },
    async ResetPassword(data){
        const response = await axios.post('/api/auth/reset-password',data,anonymous)
        return response
    },
}
